import gql from 'graphql-tag';

export const IncidentCategories = gql`
  query IncidentCategories($organizationId: ID!) {
    organization(organizationId: $organizationId) {
      id
      incidentCategories {
        id
        name
        color
      }
    }
  }
`;
